var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.52,106.99c0-8.86-0.21-14.98,0.05-21.07c0.36-8.37,5.49-13.02,13.34-13.14c7.89-0.12,13.49,4.51,13.66,12.77 c0.4,19.05,0.44,38.12,0.04,57.17c-0.18,8.49-5.17,13.57-14.04,13.62c-18.33,0.11-36.66,0.12-54.98-0.01 c-8.86-0.06-13.9-5.27-13.98-13.66c-0.09-8.54,5.25-13.45,13.94-13.79c6.89-0.27,13.81-0.05,20.71-0.05c0.98-1.33,1.95-2.66,2.93-4 c-2.86-1.45-6.11-2.43-8.52-4.43C277.1,48.9,143.86,79.77,97.52,182.16C48.2,291.11,117.61,414.38,236.11,428.29 c97.3,11.42,187.92-66.45,191.39-164.45c0.58-16.34,4.84-22.75,14.74-22.18c9.53,0.55,12.98,6.73,12.62,22.64 c-2.41,106.02-92.95,193.27-201.26,191.7c-84.1-1.22-146.56-41.1-181.04-117.31c-34.77-76.86-23.91-151.06,31.11-215.6 c71.11-83.41,193.97-92.55,278.4-22.89C384.02,101.81,386.01,103.37,390.52,106.99z",
    fill: "#00ffb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.78,255.35c0.01-9.16-0.34-18.34,0.07-27.49c1.47-32.77,32.15-51.85,61.91-38.01c18.9,8.78,37.87,17.8,55.55,28.74 c30.01,18.58,27.69,59.94-3.57,76.13c-17.23,8.92-34.52,17.75-52.1,25.96c-29.62,13.84-60.42-5.12-61.81-37.85 C184.44,273.68,184.77,264.51,184.78,255.35z",
    fill: "#00ffb9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.a198b5319d085b58b4c0842b48995464.svg";
export { ForwardRef as ReactComponent };